<section id="menu-purchase" (mouseleave)="closeMenu()">
  @if (!isMobile()) {
  <div class="container">
    <div id="close-menu-purchase">
      <img class="previus-menu" src="/icons/close.svg" loading="lazy" (click)="closeMenuMovil()" />
      <p id="buy" class="text-uppercase">Compra en línea</p>
    </div>
    <div class="d-flex">
      <a href="https://parts.cat.com/es/tracsa" target="_blank">
        <div class="box-category">
          <span>PARTS.CAT.COM</span>
          <img [src]="'/general/1_e.png'" loading="lazy" />
        </div>
      </a>
      <a href="http://llantrac.com.mx" target="_blank">
        <div class="box-category">
          <span>Llantas</span>
          <img [src]="'/general/2_e.png'" loading="lazy" />
        </div>
      </a>
      <a href="https://boutique.tracsa.com.mx" target="_blank">
        <div class="box-category">
          <span>Boutique</span>
          <img [src]="'/general/4_e.png'" loading="lazy" />
        </div>
      </a>
    </div>
  </div>
  } @else {
  <div class="container-fluid">
    <div class="titleMegaMenu">
      @if (isMobile()) {
      <button class="btnBackMegamenu" (click)="closeMenuMovil()">
        <div class="contentImage">
          <img src="/general/chevron-left.svg" alt="left arrow" width="24" height="24" />
        </div>
      </button>
      <span>COMPRA EN LÍNEA</span>
      }
    </div>
    <div class="links">
      <a class="linkItem" href="https://parts.cat.com/es/tracsa" target="_blank">
        <span>Parts.cat.com</span>
      </a>
      <a class="linkItem" href="http://llantrac.com.mx" target="_blank">
        <span>Llantas</span>
      </a>
      <a class="linkItem" href="https://boutique.tracsa.com.mx" target="_blank">
        <span>Boutique</span>
      </a>
    </div>
  </div>
  }
</section>
